import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const OrderStatusDropdown = ({ orderId, currentStatus, onStatusUpdated }) => {
  const [status, setStatus] = useState(currentStatus);
  const [loading, setLoading] = useState(false);

  const statuses = ["processing", "shipped", "delivered", "canceled"];

  const handleChange = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    setLoading(true);

    try {
      const res = await axios.patch(
        `/orders/${orderId}/status`,
        { status: newStatus },
        { withCredentials: true }
      );

      onStatusUpdated?.(res.data); // Callback to refresh list if needed
    } catch (err) {
      console.error("Failed to update status:", err.response?.data?.error || err.message);
      toast.error("Failed to update status");
      setStatus(currentStatus); // revert
    } finally {
      setLoading(false);
    }
  };

  return (
    <select value={status} onChange={handleChange} disabled={loading}>
      {statuses.map((s) => (
        <option key={s} value={s}>
          {s.charAt(0).toUpperCase() + s.slice(1)}
        </option>
      ))}
    </select>
  );
};

export default OrderStatusDropdown;
